import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../helper/urls.js";
import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/slices/authSlice";

const SignInLayer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const url = `${baseUrl}/api/users/login`;

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const formSubmited = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { email, password } = formData;
      const response = await axios.post(url, { email, password });

      console.log(response, "response login");

      if (response.status === 200 && response.data.token) {
        toast.success(response.data.message);

        // Dispatch login success to Redux
        dispatch(
          loginSuccess({
            token: response.data.token,
            name: response.data.name,
            role: "admin",
            email: response.data.email,
          })
        );

        setTimeout(() => navigate("/all-counselors"), 500);
      } else {
        toast.error(response.data.error || "Login failed.");
      }
    } catch (error) {
      console.error("Login failed:", error);
      toast.error("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <section className="auth bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="assets/images/auth/auth-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="assets/images/logo.png" alt="" />
              </Link>
              <h4 className="mb-12">Sign In to your Account</h4>
              <p className="mb-32 text-secondary-light text-lg">
                Welcome back! please enter your detail
              </p>
            </div>
            <form onSubmit={formSubmited}>
              <div className="icon-field mb-16">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:email" />
                </span>
                <input
                  type="email"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChanges}
                  required
                />
              </div>
              <div className="position-relative mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type="password"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    id="your-password"
                    placeholder="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleChanges}
                    required
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between gap-2">
                <Link
                  to="/admin-forgot-password"
                  className="text-primary-600 fw-medium"
                >
                  Forgot Password?
                </Link>
              </div>
              <div>
                {loading ? (
                  <button
                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                    type="submit"
                    disabled
                  >
                    <CircularProgress color="inherit" size={25} />
                  </button>
                ) : (
                  <button
                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                    type="submit"
                  >
                    Sign In
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignInLayer;

// import { Icon } from "@iconify/react/dist/iconify.js";
// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { baseUrl } from "../helper/urls.js";
// import { CircularProgress } from "@mui/material";
// // import { FaUser } from "react-icons/fa";
// const SignInLayer = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const url = `${baseUrl}/api/users/login`;
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     // role: "",
//   });

//   const handleChanges = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formSubmited = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const { email, password, role } = formData;

//       const data = { email, password, role };
//       const response = await axios.post(url, data);

//       if (response.status === 200 && response?.data?.token) {
//         toast.success(response.data.message);
//         sessionStorage.setItem("token", response.data.token);
//         sessionStorage.setItem("user", "admin");
//         sessionStorage.setItem("name", response.data.name);
//         sessionStorage.setItem("email", response.data.email);
//         setTimeout(() => navigate("/all-counselors"), 500);
//         // setTimeout(() => navigate("/dashboard"), 500);
//         setLoading(false);
//       } else {
//         setLoading(false);
//         console.log("respomse", response);
//         toast.error(response.data.error);
//       }
//     } catch (error) {
//       setLoading(false);

//       console.error("Login failed:", error);
//       toast.error("Login failed. Please check your credentials.");
//     }
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} />
//       <section className="auth bg-base d-flex flex-wrap">
//         <div className="auth-left d-lg-block d-none">
//           <div className="d-flex align-items-center flex-column h-100 justify-content-center">
//             <img src="assets/images/auth/auth-img.png" alt="" />
//           </div>
//         </div>
//         <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
//           <div className="max-w-464-px mx-auto w-100">
//             <div>
//               <Link to="/" className="mb-40 max-w-290-px">
//                 <img src="assets/images/logo.png" alt="" />
//               </Link>
//               <h4 className="mb-12">Sign In to your Account</h4>
//               <p className="mb-32 text-secondary-light text-lg">
//                 Welcome back! please enter your detail
//               </p>
//             </div>
//             <form onSubmit={formSubmited}>
//               {/* <div className="icon-field mb-16">
//                 <span className="icon top-50 translate-middle-y">
//                   <Icon icon="fa-regular:user" />
//                 </span>
//                 <select
//                   name="role"
//                   id="role"
//                   onChange={handleChanges}
//                   className="form-control h-56-px bg-neutral-50 radius-12"
//                 >
//                   <option value="select role" hidden>
//                     Select Role
//                   </option>
//                   <option value="admin">Admin</option>
//                   <option value="counselor">Counselor</option>
//                   <option value="student">Student</option>
//                 </select>
//               </div> */}
//               <div className="icon-field mb-16">
//                 <span className="icon top-50 translate-middle-y">
//                   <Icon icon="mage:email" />
//                 </span>
//                 <input
//                   type="email"
//                   className="form-control h-56-px bg-neutral-50 radius-12"
//                   placeholder="Email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChanges}
//                   required
//                 />
//               </div>
//               <div className="position-relative mb-20">
//                 <div className="icon-field">
//                   <span className="icon top-50 translate-middle-y">
//                     <Icon icon="solar:lock-password-outline" />
//                   </span>
//                   <input
//                     type="password"
//                     className="form-control h-56-px bg-neutral-50 radius-12"
//                     id="your-password"
//                     placeholder="Password"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChanges}
//                     required
//                   />
//                 </div>
//                 {/* <span
//                   className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
//                   data-toggle="#your-password"
//                 /> */}
//               </div>
//               <div className="d-flex justify-content-between gap-2">
//                 <Link
//                   to="/admin-forgot-password"
//                   className="text-primary-600 fw-medium"
//                 >
//                   Forgot Password?
//                 </Link>
//               </div>
//               {/* <button
//                 type="submit"
//                 className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
//               >
//                 Sign In
//               </button> */}
//               <div>
//                 {loading ? (
//                   <button
//                     // className="btn btn-primary rounded-pill px-5 py-2"
//                     className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
//                     type="submit"
//                     disabled
//                   >
//                     <CircularProgress color="white" size={25} />
//                   </button>
//                 ) : (
//                   <button
//                     // className="btn btn-primary rounded-pill px-5 py-2"
//                     className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
//                     type="submit"
//                   >
//                     Sign In
//                   </button>
//                 )}
//                 {/* <button
//                                       className="btn btn-primary rounded-pill px-5 py-2"
//                                       type="submit"
//                                     >
//                                       {isEdit ? "Update" : "Save"}
//                                     </button> */}
//               </div>
//             </form>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default SignInLayer;
